import { useIntlModule } from 'utils/intl/useIntlModule';
import messages from './engagementStatus.intl.json';

export const useEngagementStatusIntl = () => useIntlModule(messages);
